(function(){
    'use strict'; 
    angular.module('Services').service('AccountingCustomersBillingSettingsTable', AccountingCustomersBillingSettingsTable); 
    AccountingCustomersBillingSettingsTable.$inject = [
        '$uibModal', 
        'TableLiteFactory',
        'toastr', 
        'AccountingService', 
        'ConfirmationModalFactory'
    ]; 

    function AccountingCustomersBillingSettingsTable(
        $uibModal, 
        TableLiteFactory,
        toastr,
        AccountingService,
        ConfirmationModalFactory 
    ){
        return function() {
            const deleteConfirmation = new ConfirmationModalFactory({}, {
                message: 'messages.warning.deleteSettings.MESSAGE',
                code: 'messages.warning.deleteSettings.CODE',
            });

            const tableData = {
                config: {
                    noPagination: false, 
                    noHeaders: false, 
                    noItemsView: false, 
                    noTableFooter: false, 
                    colMinWidth: '135px'
                }, 
                optionAddOns: {
                    buttons: [{
                        class: 'btn-primary', 
                        label: 'ADD NEW CUSTOMER BILLING SETTINGS', 
                        tooltip: 'Click to add new customer billing settings',
                        onClick: () => {
                            showCustomerSettingsDetailsModal(null);
                        }
                    }]
                },
                headers: [
                    {
                        label: 'Customer', 
                        viewName: 'customerName', 
                        filterName: 'customer.name',
                        sortName: 'customerId',
                        filter: {
                            type: 'text',
                            placeholder: 'Search',
                            onSubmit: function (header) {
                                tableActions.sendRequest(tableActions.evaluateFilter(header));
                            }
                        },
                        headerFn: function () {
                            tableActions.sort(this.sortName);
                        }
                    }, 
                    {
                        label: 'Global Settings', 
                        width: '10px',
                        viewName: 'globalSettings', 
                    },
                    {
                        label: 'Billing Frequency', 
                        viewName: 'billingFrequency', 
                    }, 
                    {
                        label: 'Billing Cycle Start Date', 
                        viewName: 'billingCycleStartDate'
                    }, 
                    {
                        label: 'Due Date', 
                        viewName: 'billingCycleDueDate'
                    }, 
                    {
                        label: 'Enable Automatic Billing', 
                        viewName: 'enableAutomaticBilling'
                    }, 
                    {
                        label: 'Action',
                        viewName: 'action',
                        width: '100px',
                        class: 'text-center'
                    }
                ],
                data: [], 
                resetFilter: ()=>{
                    tableActions.resetFilters();
                }, 
                onInit: ()=>{
                    tableActions.sendRequest({});
                }
            }

            const tableActions = new TableLiteFactory(tableData, {
                serviceCallback: AccountingService.CustomersBillingSettings.getAll, 
                callbackFormat: ['success', 'error', 'filter'], 
                postRequestCallback: data=>{
                    buildTableData(data);
                }, 
                postRequestErrorCallback: err=>{
                    buildTableData(null);
                    toastr.error(err);
                }, 
                defaultFilters: {
                    size: 20, 
                    page: 0, 
                    sort: 'id,desc'
                }
            });

            function buildTableData(data){
                if(!data) {
                    return tableData; 
                }

                tableActions.initializeTableData(data); 
                angular.forEach(data.content, (item)=>{
                    item.customerName = item.customer ? item.customer.name : `${item.company.name} (Global Settings)`; 
                    item.globalSettings = item.customer === null ? 'Yes' : 'No';
                    item.billingFrequency = item.billingFrequency.toUpperCase();
                    item.billingCycleStartDate = item.cycleStartDate ? `${item.cycleStartDate } Of Month` : 'N/A'; 
                    item.billingCycleDueDate = item.dueDate ? `${item.dueDate} Of Month` : 'N/A';
                    item.enableAutomaticBilling = item.automaticBilling ? 'Yes' : 'No';
                    
                    item.action = {
                        type: 'button', 
                        buttons: [{
                            text: 'view',
                            class: 'btn bnt-sm btn-quirk btn-primary', 
                            action: row=>{
                                showCustomerSettingsDetailsModal(row);
                            }
                        },
                        {
                            text: 'delete', 
                            class: 'btn btn-sm btn-quirk btn-danger', 
                            action: row => {
                                showDeleteConfirmationModal(row);
                            }
                        }]
                    }

                    tableData.data.push(item);
                });
            }

            function showCustomerSettingsDetailsModal(data){
                const modalInstance = $uibModal.open({
                    animation: true,
                    ariaLabelledBy: 'modal-title',
                    ariaDescribedBy: 'modal-body',
                    windowClass: 'setting-modal',
                    templateUrl: '/templates/pages/accounting/customer-billing-settings-modal.html',
                    controller: 'AccountingCustomerSettingsModalController',
                    controllerAs: 'vm',
                    size: 'md',
                    appendTo: $('body'),
                    resolve: {
                        settingsData: ()=> data
                    }
                });

                modalInstance.result.then(() => {
                    tableActions.sendRequest({});
                });
            }

            function showDeleteConfirmationModal(data){
                if(data.customer === null) {
                    toastr.warning("Global settings cannot be deleted."); 
                } else {
                    deleteConfirmation.getInstance().result.then(cond => {
                        if(cond) {
                            data.action.buttons[1].text = "Deleting...";
                            AccountingService.CustomersBillingSettings.delete(success => {
                                tableData.data = tableData.data.filter( item => item.id !== data.id);
                                toastr.success('Customer Billing Settings Deleted');
                            }, error => {
                                data.action.buttons[1].text = "delete";
                                toastr.error(error.message);
                            }, data.id);
                        }
                    });
                }
            }
            this.tableData = tableData;
        }
    }
})();


// WEBPACK FOOTER //
// ./js/services/tables/accountingTables/AccountingCustomersBillingSettingsTable.js